import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { BrowserRouter } from 'react-router-dom';

import { GlobalErrorBoundaryWithoutStyles } from 'error-boundaries';
import { MainLayout } from 'layouts/MainLayout';
import { PrivateRoutes } from 'routes';
import { theme } from 'theme';

import {
  NotifyProvider,
  AuthProvider,
  ApolloProvider,
  BootstrapProvider,
} from '.';

export function AppContext(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <NotifyProvider>
        <GlobalErrorBoundaryWithoutStyles>
          <AuthProvider>
            <ApolloProvider>
              <BootstrapProvider>
                <BrowserRouter>
                  <CssBaseline />
                  <MainLayout>
                    <PrivateRoutes />
                  </MainLayout>
                </BrowserRouter>
              </BootstrapProvider>
            </ApolloProvider>
          </AuthProvider>
        </GlobalErrorBoundaryWithoutStyles>
      </NotifyProvider>
    </ThemeProvider>
  );
}
